import { z } from "zod"

/**
 * How a signal was created — immutable, set at creation, never changes.
 *   user   — hand-built by a person; MUST have an evaluation; never annotation-assignable.
 *   system — auto-generated by discovery; annotation-assignable, even after it is tracked with an evaluation.
 * Distinct from the mutable "has no evaluation yet" state, and the gate for annotation assignment;
 * tell auto-generated from hand-built by `origin`, never by the presence of an evaluation.
 */
export const SIGNAL_ORIGINS = ["user", "system"] as const
export const signalOriginSchema = z.enum(SIGNAL_ORIGINS)
export type SignalOrigin = z.infer<typeof signalOriginSchema>
